import React from 'react';
import { Routes as RouterRoutes, Route, Navigate } from 'react-router-dom';

import Home from '../components/Home/Home';
import About from '../components/About/About';
import Portfolios from '../components/Portfolios/Portfolios';
import Resume from '../components/Resume/Resume';
import Contact from '../components/Contact/Contact';

const Routes = () => {
  return (
    <RouterRoutes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/portfolios" element={<Portfolios />} />
      <Route path="/resume" element={<Resume />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </RouterRoutes>
  );
};

export default Routes;
